import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/Button";
import { forword } from "../../actions/studensts";
import AlertSuccess from "../../components/AlertSuccess";
import AlertDenger from "../../components/AlertDenger";
import Loading from "../../components/Loading";
import { useState } from "react";

export default function ActionButtonsPending() {
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [text, setText] = useState("");
  const [loading1, setLoading1] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading1(false);
      // navigate("/main/score/score_pending");
    }, 2000);
  }

  const handleForward1 = async () => {
    setLoading1(true);
    const res = await forword(
      id,
      "scorehandler/",
      "mohe_validation",
      JSON.parse(localStorage.getItem("profile"))?.value[0].username,
    );
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.ERROR);
    }
  };

  return (
    <div className="pt-4 space-y-3">
      {showSuccessAlert && <AlertSuccess text={text} />}
      {showDengerAlert && <AlertDenger text={text} />}
      <div className="flex flex-wrap gap-3">
        <Button
          color="bg-emerald-600 hover:bg-emerald-500 disabled:bg-white/10 disabled:text-slate-500"
          onClick={handleForward1}
          disabled={loading1}
          text={!loading1 ? "Forward to MOHE Validation" : <Loading />}
        />
        <Button
          color="bg-indigo-600 hover:bg-indigo-500"
          onClick={() => {
            navigate("/main/score/score_pending/comment", { state: id });
          }}
          text="Comment"
        />
      </div>
    </div>
  );
}
